import React, { Fragment, useEffect, useState, useRef } from "react";
import swal from "sweetalert";
import {
  notifyTopRight,
  notifyWarning,
  notifyError,
} from "../../toast/SetToast";
import { useHistory } from "react-router-dom";
import { Dropdown, Modal, Button } from "react-bootstrap";
import { db } from "../../../../firebase";
import {
  collection,
  updateDoc,
  doc,
  query,
  limit,
  deleteDoc,
  orderBy,
  where,
  Query,
  or,
  getDocs,
  and,
} from "firebase/firestore";
import CPAPServiceItem from "./CPAPServiceItem";
import CPAPServiceRegister from "./CPAPServiceRegister";
import CPAPServiceEdit from "./CPAPServiceEdit";
import { useFirestore } from "../../../../hook/useFirestore";
import { usePagination } from "../../../../hook/usePagination";
import PageTitle from "../../../layouts/PageTitle";
import useQueryParams from "../../../../hook/useQueryParam";

const CPAPServiceItemList = () => {
  const [itemList, setItemList] = useState([]);
  const [showRegisterModal, setShowRegisterModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [itemEdit, setItemEdit] = useState({});
  const [copyItem, setCopyItem] = useState({});
  const [sortBy, setSortBy] = useState("brand");
  const [sortDrirection, setSortDrirection] = useState("asc");
  const [statusFilter, setStatusFilter] = useState("ทั้งหมด");
  const [itemsPerPage, setItemsPerPage] = useState(25);
  const [searchItem, setSearchItem] = useState(null);

  const searchRef = useRef("");

  const sortByList = ["brand", "model", "price"];
  const sortDrirectionList = ["asc", "desc"];
  const statusList = ["ทั้งหมด", "Active", "Inactive"];

  let QueryFilterConstraint = [];
  let queryRef = query(
    collection(db, "cpapService"),
    orderBy(sortBy, sortDrirection)
  );

  if (searchItem !== null) {
    QueryFilterConstraint.push(
      where("brand", ">=", searchItem),
      where("brand", "<=", searchItem + "\uf8ff")
    );

    queryRef = query(
      collection(db, "cpapService"),
      and(...QueryFilterConstraint),
      orderBy(sortBy, sortDrirection)
    );
  }

  if (statusFilter !== null) {
    queryRef = query(
      collection(db, "cpapService"),
      and(
        ...QueryFilterConstraint,
        or(where("IsActive", "==", statusFilter !== null ? statusFilter : ""))
      ),
      orderBy(sortBy, sortDrirection)
    );

    if (statusFilter === "ทั้งหมด") {
      queryRef = query(
        collection(db, "cpapService"),
        orderBy(sortBy, sortDrirection)
      );

      if (searchItem !== null) {
        QueryFilterConstraint.push(
          where("brand", ">=", searchItem),
          where("brand", "<=", searchItem + "\uf8ff")
        );

        queryRef = query(
          collection(db, "cpapService"),
          and(...QueryFilterConstraint),
          orderBy(sortBy, sortDrirection)
        );
      }
    }
  }

  const {
    items: itemInfo,
    isLoading,
    isStart,
    isEnd,
    getPrev,
    getNext,
    totalItems,
    totalPages,
    currentPage,
    goToPage,
  } = usePagination(queryRef, { limit: itemsPerPage });

  const { addDocument, deleteDocument } = useFirestore("cpapService");

  const handleOnNewItem = () => {
    setShowRegisterModal(true);
  };

  const handleOnEdit = async (id) => {
    setItemEdit(itemInfo.find((item) => item.id === id));
    setShowEditModal(true);
  };

  const handleOnCopy = async (id) => {
    const cpapServiceToCopy = itemInfo.find((item) => item.id === id);
    setCopyItem(cpapServiceToCopy);

    const formData = {
      brand: cpapServiceToCopy.brand,
      model: cpapServiceToCopy.model + " (Copy)",
      withHumidifier: cpapServiceToCopy.withHumidifier,
      price: cpapServiceToCopy.price,
      humidifierPrice: cpapServiceToCopy.humidifierPrice,
      tubePrice: cpapServiceToCopy.tubePrice,
      rentalPrice: cpapServiceToCopy.rentalPrice,
      IsActive: cpapServiceToCopy.IsActive,
    };

    addDocument(formData)
      .then(() => {
        notifyTopRight("คัดลอกข้อมูลสำเร็จ");
      })
      .catch((err) => {
        console.log(err);
        notifyError("คัดลอกข้อมูลผิดพลาด ", err);
      });
  };

  const handleOnRegisterHide = () => {
    setShowRegisterModal(false);
  };

  const handleOnEditHide = () => {
    setShowEditModal(false);
  };

  const handleOnDelete = (id) => {
    swal({
      title: "คุณแน่ใจที่จะลบข้อมูลนี้?",
      text: "เมื่อลบแล้ว คุณจะไม่สามารถกู้คืนข้อมูลนี้ได้!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        deleteDocument(id)
          .then(() => {
            notifyTopRight("ลบข้อมูลสำเร็จ");
          })
          .catch((err) => {
            notifyError("ลบข้อมูลไม่สำเร็จ", err);
          });
      }
    });
  };

  const handleSearchChange = () => {
    setSearchItem(searchRef.current.value);
  };

  const handleStatusChange = (status) => {
    setStatusFilter(status);
  };

  const handleSortDrirectionChange = (drirection) => {
    setSortDrirection(drirection);
  };

  return (
    <Fragment>
      <PageTitle
        activeMenu="CPAP Services"
        motherMenu="Items"
        pageContent="CPAP Services"
      />

      <div className="form-head d-flex mb-3 mb-lg-5 align-items-start">
        <Button
          className="btn btn-danger"
          onClick={handleOnNewItem}
          data-toggle="tooltip"
          data-placement="top"
          title="CPAP Service Registration"
        >
          + Add New
        </Button>
        <div className="input-group search-area ml-auto d-inline-flex">
          <input
            type="text"
            className="form-control"
            placeholder="Search Item"
            ref={searchRef}
            onChange={handleSearchChange}
          />
          <div className="input-group-append">
            <span className="input-group-text c-pointer">
              <i className="flaticon-381-search-2"></i>
            </span>
          </div>
        </div>
        <Dropdown
          className="align-items-end d-inline-flex ml-2"
          onSelect={(option) => handleSortDrirectionChange(option)}
        >
          <Dropdown.Toggle variant="outline-primary" id="dropdown-basic">
            <i className="flaticon-381-controls-3 "></i> by{" "}
            {sortDrirection === "asc" ? "A-Z" : "Z-A"}
          </Dropdown.Toggle>
          <Dropdown.Menu className="dropdown-menu-right">
            {sortDrirectionList.map((element, index) => {
              return (
                <Dropdown.Item href="#" eventKey={element}>
                  {element === "asc" ? "A-Z" : "Z-A"}
                </Dropdown.Item>
              );
            })}
          </Dropdown.Menu>
        </Dropdown>
        <Dropdown
          className="align-items-end d-inline-flex ml-2"
          onSelect={(option) => handleStatusChange(option)}
        >
          <Dropdown.Toggle variant="outline-primary" id="dropdown-basic">
            <i className="flaticon-381-menu-1"></i>
            {statusFilter === "ทั้งหมด" && "Status"} {statusFilter}
          </Dropdown.Toggle>
          <Dropdown.Menu className="dropdown-menu-right">
            {statusList.map((element, index) => {
              return (
                <Dropdown.Item href="#" eventKey={element}>
                  {element}
                </Dropdown.Item>
              );
            })}
          </Dropdown.Menu>
        </Dropdown>
      </div>
      <CPAPServiceItem
        items={itemInfo}
        onEdit={handleOnEdit}
        onDelete={handleOnDelete}
        onCopy={handleOnCopy}
        totalItems={totalItems}
        totalPages={totalPages}
        currentPage={currentPage}
        itemsPerPage={itemsPerPage}
        goToPage={goToPage}
        isStart={isStart}
        isEnd={isEnd}
        getNext={getNext}
        getPrev={getPrev}
      />
      <CPAPServiceRegister
        show={showRegisterModal}
        hide={handleOnRegisterHide}
      />

      <CPAPServiceEdit
        show={showEditModal}
        hide={handleOnEditHide}
        item={itemEdit}
      />
    </Fragment>
  );
};

export default CPAPServiceItemList;
